<template>
  <common-dialog
    v-loading="loading"
    ref="dialog"
    :title="dialogTitle"
    :width="50"
    :inputs-map="addressForm"
    :input-value-change="valueChange"
    :save-cb="saveNewAddress"
    :reset-inputs="resetInputs"
  >
    <template v-slot:content>
      <div class="location-card f-c">
        <div id="map" class="mapbox" />
        <div class="f-r buttons">
          <el-button plain type="primary" size="mini" @click="getLocation">
            Locate
          </el-button>
        </div>
      </div>
    </template>
  </common-dialog>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
// models
import { NewAddressForm } from '@/core/models/address'
// mixin
import { dialogMixin } from '@/core/mixin/dialog'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
import { queryAddressGeo, saveAddress } from '@/api/address'
import { mapGetters } from 'vuex'
const mapboxgl = require('mapbox-gl')

export default {
  name: 'AddressNew',
  mixins: [dialogMixin],
  components: {
    CommonDialog
  },
  data() {
    return {
      originAddress: null,
      addressForm: cloneDeep(NewAddressForm),
      loading: false,
      saveCb: null,
      mapbox: null,
      marker: null
    }
  },
  computed: {
    ...mapGetters(['mapboxToken']),
    isEdit() {
      return !!this.originAddress
    },
    dialogTitle() {
      return this.isEdit ? 'Edit Address' : 'New Address'
    }
  },
  methods: {
    saveNewAddress(info, done, error) {
      this.loading = true
      saveAddress(info)
        .then(res => {
          done()
          this.saveCb?.(res)
        })
        .catch(err => error(err.toString()))
        .finally(() => {
          this.loading = false
        })
    },
    open(data = null, saveCb) {
      this.originAddress = data
      this.resetAdderessForm()
      this.$refs.dialog.open()
      this.saveCb = saveCb
      setTimeout(() => {
        if (!this.mapbox) {
          this.mapbox = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v11',
            interactive: false,
            maxZoom: 18,
            center: [-118.028264, 33.896343]
          })
        }
      }, 300)
    },
    getLocation() {
      const valueMap = Object.fromEntries(
        this.addressForm.map(one => [one.key, one.value])
      )
      if (!valueMap.street || !valueMap.city || !valueMap.state) {
        this.$refs.dialog.error('Street, City and State are required!')
        return
      }
      queryAddressGeo({
        ...valueMap
      })
        .then(res => {
          if (res) {
            if (this.marker) this.marker.remove()
            this.marker = new mapboxgl.Marker({ color: 'red' })
              .setLngLat([res.lng, res.lat])
              .addTo(this.mapbox)
            this.mapbox.flyTo({
              center: [res.lng, res.lat],
              zoom: 12
            })
          }
        })
        .catch(err => {
          this.$refs.dialog.error(err.toString())
        })
    },
    resetInputs() {
      this.addressForm.forEach(one => {
        one.value = one.default
      })
    },
    valueChange() {},
    resetAdderessForm() {
      const inputs = Object.keys(NewAddressForm).map(key => {
        return {
          ...NewAddressForm[key],
          value: get(this.originAddress, key)
        }
      })
      this.$set(this, 'addressForm', inputs)
    }
  },
  mounted() {
    mapboxgl.accessToken = this.mapboxToken
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.location-card {
  flex-grow: 1;
  height: 300px;
  width: 100%;
  margin-bottom: 10px;

  #map {
    width: 100%;
    flex-grow: 1;
    border-radius: 4px;
  }

  .buttons {
    margin-top: 5px;
    justify-content: flex-end;
  }
}
</style>
